import React, { useState } from "react";
import "../Styles/style.css";
import Payments from "../../images/Payment-methods.png";
import PayVector from "../../images/member-vector.png";
import FormVector from "../../images/formVector.png";
import InputMask from "react-input-mask";
import axios from "axios";
import PaymentSuccess from "../modals/payment-success.jsx";
import PaymentRejected from "../modals/payment-rejected.jsx";
import { useHistory } from "react-router-dom";
import CryptoJS from "crypto-js";
import moment from "moment";
import { baseUrl } from "../../api/ipconfig.js";
import { AuthContext } from "../../context/AuthContext.js";
import BecomeMember from "../../images/become-member.png";
import DocVerify from "../../images/doc-verify.png";
import Purchase from "../../images/bid.png";
import GoBidding from "../../images/go-for-bidding.png";

function hash_hmac_sha256(data, key) {
  return CryptoJS.HmacSHA256(data, key).toString();
}

export default function BuyMoreBidds() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [cnic, setCnic] = useState(null);
  const [address, setAddress] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [data, setData] = useState();
  const [Apiuser, setApiUser] = useState(null);
  // const [shouldHide, setShouldHide] = useState(true);
  const [value, setValue] = useState(10000);

  const [successIsOpen, setSuccessIsOpen] = React.useState(false);
  const [rejectedOpen, setRejectedOpen] = useState(false);

  const LoginClose = () => {
    setSuccessIsOpen(false);
  };

  const rejectedClose = () => {
    setRejectedOpen(false);
  };

  const history = useHistory();

  const goToVerify = () => {
    history.push(`/profile?${token}`);
  };

  const token = localStorage.getItem("token");

  const fetchUserPosts = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`${baseUrl}/getUser`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPhone(response?.data?.phone);
      setEmail(response?.data?.email);
      setFullName(response?.data?.name);
      setApiUser(response?.data);
    } catch (error) {}
  };

  React.useEffect(() => {
    fetchUserPosts();
  }, []);

  React.useEffect(() => {
    // Parse query parameters and access response data
    const params = new URLSearchParams(window.location.search);
    const responseCode = params.get("responsecode");
    const responseMessage = params.get("ResponseMessage");
    // Use the response data as needed in your React component
    console.log("Response Code:", responseCode);
    console.log("Response Message:", responseMessage);

    if (
      responseCode === "000" ||
      responseCode === "200" ||
      responseCode === "121"
    ) {
      setSuccessIsOpen(true);
      setTimeout(() => {
        setSuccessIsOpen(false);
        history.push("/");
      }, 4000);
    } else if (
      responseCode === "110" ||
      responseCode === "124" ||
      responseCode === "210" ||
      responseCode === "157" ||
      responseCode === "500" ||
      responseCode === "115" ||
      responseCode === "400"
    ) {
      setRejectedOpen(true);
      setTimeout(() => {
        setRejectedOpen(false);
      }, 4000);
    } else {
    }
  }, [history]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/memberpayment`, {
          params: {
            amount: value,
          },
        });
        setData(response.data);
        // setShouldHide(true);
        console.log("member form response", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [value]);

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (password !== value) {
      setPasswordMatchError("Passwords did not match");
    } else {
      setPasswordMatchError("");
    }
  };

  const increaseValue = () => {
    setValue((prevValue) => prevValue + 10000);
  };

  const decreaseValue = () => {
    setValue((prevValue) => prevValue - 10000);
  };

  const Amount = data?.pp_Amount;
  const BankID = 2023;
  const pp_CustomerId = 123;
  const BillReference = "billRef";
  const Description = "Fame Wheels Bidding Membership";
  const IsRegisteredCustomer = "Yes";
  const Language = "EN";
  const MerchantID = "87876565"; // for live
  // const MerchantID = "MC56944"; // for local
  const Password = "ssszc65y15"; // for live
  // const Password = "0b4ydtea9t"; // for local
  const ProductID = 2023;
  const ReturnURL = data?.pp_ReturnURL;
  const TxnCurrency = "PKR";
  const TxnDateTime = moment().format("YYYYMMDDHHmmss");
  const TxnExpiryDateTime = moment().add(1, "days").format("YYYYMMDDHHmmss");
  let transID = "T" + Math.floor(Math.random() * 1000000000000);
  const TxnRefNumber = transID;
  const TxnType = "MPAY";
  const Version = data?.pp_Version;

  const HashKey = "ue19u14273"; // for live
  // const HashKey = "034298d8a4"; // for local
  // const SortedArray = `${HashKey}&${Amount}&${BankID}&${BillReference}&${Description}&${IsRegisteredCustomer}&${Language}&${MerchantID}&${Password}&${ProductID}&${fullName}&${email}&${phone}&${address}&${cnic}&${ReturnURL}&${TxnCurrency}&${TxnDateTime}&${TxnExpiryDateTime}&${TxnRefNumber}&${Version}`;
  // const SortedArray = `${HashKey}&${Amount}&${address}&${BillReference}&${cnic}&${Description}&${email}&${fullName}$${IsRegisteredCustomer}&${Language}&${MerchantID}&${Password}&${phone}&${ReturnURL}&${TxnCurrency}&${TxnDateTime}&${TxnExpiryDateTime}&${TxnRefNumber}&${Version}`;
  // const SortedArray = `${HashKey}&${Amount}&${BillReference}&${email}&${pp_CustomerId}&${phone}&${Description}&${IsRegisteredCustomer}&${Language}&${MerchantID}&${Password}&${ReturnURL}&${TxnCurrency}&${TxnDateTime}&${TxnExpiryDateTime}&${TxnRefNumber}&${TxnType}&${Version}&${fullName}&${email}&${phone}&${cnic}&${address}`;

  const handleFormSubmit = () => {
    if (data) {
      const SortedArray = `${HashKey}&${Amount}&${BillReference}&${Description}&${IsRegisteredCustomer}&${Language}&${MerchantID}&${Password}&${ReturnURL}&${TxnCurrency}&${TxnDateTime}&${TxnExpiryDateTime}&${TxnRefNumber}&${Version}&${fullName}&${email}&${phone}&${cnic}&${address}`;
      const result = hash_hmac_sha256(SortedArray, HashKey);
      console.log(SortedArray, "SortedArray");
      console.log(result, "result");
      // Once the form data is available, construct the form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action =
        "https://payments.jazzcash.com.pk/CustomerPortal/transactionmanagement/merchantform"; // URL for live
      // "https://sandbox.jazzcash.com.pk/CustomerPortal/transactionmanagement/merchantform/"; // URL for local

      // Add input fields with their values from the formData object
      // for (const [key, value] of Object.entries(data)) {
      //   const input = document.createElement("input");
      //   input.type = "hidden";
      //   input.name = key;
      //   input.value = value;
      //   form.appendChild(input);
      // }

      // Add the name field from the state to the form
      const CustomerIdInput = document.createElement("input");
      CustomerIdInput.type = "hidden";
      CustomerIdInput.name = "pp_CustomerId";
      CustomerIdInput.value = "";
      form.appendChild(CustomerIdInput);

      const returnInput = document.createElement("input");
      returnInput.type = "hidden";
      returnInput.name = "pp_ReturnURL";
      returnInput.value = ReturnURL;
      form.appendChild(returnInput);

      // const ppMobileInput = document.createElement("input");
      // ppMobileInput.type = "hidden";
      // ppMobileInput.name = "pp_mobile";
      // ppMobileInput.value = "";
      // form.appendChild(ppMobileInput);

      // const ppCNICInput = document.createElement("input");
      // ppCNICInput.type = "hidden";
      // ppCNICInput.name = "pp_cnic";
      // ppCNICInput.value = "";
      // form.appendChild(ppCNICInput);

      // const bankInput = document.createElement("input");
      // bankInput.type = "hidden";
      // bankInput.name = "pp_bankID";
      // bankInput.value = "";
      // form.appendChild(bankInput);

      // const productInput = document.createElement("input");
      // productInput.type = "hidden";
      // productInput.name = "pp_productID";
      // productInput.value = "";
      // form.appendChild(productInput);

      const expiryInput = document.createElement("input");
      expiryInput.type = "hidden";
      expiryInput.name = "pp_txnExpiryDateTime";
      expiryInput.value = TxnExpiryDateTime;
      form.appendChild(expiryInput);

      const dateInput = document.createElement("input");
      dateInput.type = "hidden";
      dateInput.name = "pp_txnDateTime";
      dateInput.value = TxnDateTime;
      form.appendChild(dateInput);

      const refInput = document.createElement("input");
      refInput.type = "hidden";
      refInput.name = "pp_TxnRefNo";
      refInput.value = TxnRefNumber;
      form.appendChild(refInput);

      const typeInput = document.createElement("input");
      typeInput.type = "hidden";
      typeInput.name = "pp_TxnType";
      typeInput.value = "";
      form.appendChild(typeInput);

      const versionInput = document.createElement("input");
      versionInput.type = "hidden";
      versionInput.name = "pp_Version";
      versionInput.value = Version;
      form.appendChild(versionInput);

      const amountInput = document.createElement("input");
      amountInput.type = "hidden";
      amountInput.name = "pp_Amount";
      amountInput.value = Amount;
      form.appendChild(amountInput);

      const registeredInput = document.createElement("input");
      registeredInput.type = "hidden";
      registeredInput.name = "pp_IsRegisteredCustomer";
      registeredInput.value = "Yes";
      form.appendChild(registeredInput);

      const descriptionInput = document.createElement("input");
      descriptionInput.type = "hidden";
      descriptionInput.name = "pp_Description";
      descriptionInput.value = Description;
      form.appendChild(descriptionInput);

      // Add the name field from the state to the form
      const billRefInput = document.createElement("input");
      billRefInput.type = "hidden";
      billRefInput.name = "pp_BillReference";
      billRefInput.value = BillReference;
      form.appendChild(billRefInput);

      // Add the name field from the state to the form
      const currencyInput = document.createElement("input");
      currencyInput.type = "hidden";
      currencyInput.name = "pp_TxnCurrency";
      currencyInput.value = TxnCurrency;
      form.appendChild(currencyInput);

      // Add the name field from the state to the form
      const languageInput = document.createElement("input");
      languageInput.type = "hidden";
      languageInput.name = "pp_Language";
      languageInput.value = Language;
      form.appendChild(languageInput);

      // Add the name field from the state to the form
      const passwordInput = document.createElement("input");
      passwordInput.type = "hidden";
      passwordInput.name = "pp_Password";
      passwordInput.value = Password;
      form.appendChild(passwordInput);

      // Add the name field from the state to the form
      const merchantIDInput = document.createElement("input");
      merchantIDInput.type = "hidden";
      merchantIDInput.name = "pp_MerchantID";
      merchantIDInput.value = MerchantID;
      form.appendChild(merchantIDInput);

      // Add the name field from the state to the form
      const nameInput = document.createElement("input");
      nameInput.type = "hidden";
      nameInput.name = "ppmpf_1";
      nameInput.value = fullName;
      form.appendChild(nameInput);

      // Add the email field from the state to the form
      const emailInput = document.createElement("input");
      emailInput.type = "hidden";
      emailInput.name = "ppmpf_2";
      emailInput.value = email;
      form.appendChild(emailInput);

      const customerEmailInput = document.createElement("input");
      customerEmailInput.type = "hidden";
      customerEmailInput.name = "pp_CustomerEmail";
      customerEmailInput.value = "";
      form.appendChild(customerEmailInput);

      // Add the phone field from the state to the form
      const phoneInput = document.createElement("input");
      phoneInput.type = "hidden";
      phoneInput.name = "ppmpf_3";
      phoneInput.value = phone;
      form.appendChild(phoneInput);

      const customerPhoneInput = document.createElement("input");
      customerPhoneInput.type = "hidden";
      customerPhoneInput.name = "pp_CustomerMobile";
      customerPhoneInput.value = "";
      form.appendChild(customerPhoneInput);

      // Add the address field from the state to the form
      const addressInput = document.createElement("input");
      addressInput.type = "hidden";
      addressInput.name = "ppmpf_5";
      addressInput.value = address;
      form.appendChild(addressInput);

      // Add the CNIC field from the state to the form
      const cnicInput = document.createElement("input");
      cnicInput.type = "hidden";
      cnicInput.name = "ppmpf_4";
      cnicInput.value = cnic;
      form.appendChild(cnicInput);

      // Add the CNIC field from the state to the form
      const hashInput = document.createElement("input");
      hashInput.type = "hidden";
      hashInput.name = "pp_SecureHash";
      hashInput.value = result;
      form.appendChild(hashInput);

      // Append the form to the document body and submit it programmatically
      document.body.appendChild(form);
      form.submit();
    }
  };
  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };
  return (
    <>
      <PaymentSuccess open={successIsOpen} onClose={LoginClose} />
      <PaymentRejected open={rejectedOpen} onClose={rejectedClose} />

      <div className="container-fluid grad-bg90 py-4 ">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-lg-7 col-12">
              <h2 className=" color-white text-start fs-2">
                Become a Member <br />
                <span className="fw-bold fs-1">
                  To Bid on Your Favorite Car
                </span>
              </h2>
            </div>
            <div className="col-lg-5 col-md-12 col-12 text-end p-0">
              <img
                className="topBanner_img img-fluid "
                src={BecomeMember}
                alt="Sell through live bidding"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="newcar-main">
        <div>
          <div className="container py-5">
            <div className="memberFormHead">
              <h4 className=" color-black text-start fs-3  fw-700">
                Purchase more Bidds
              </h4>
            </div>

            <div className="row py-5">
              <div className="col-lg-12 ">
                <div
                  className="boxShadow rounded px-4 py-5"
                  style={{ background: "white" }}
                >
                  {Apiuser && Apiuser?.role_id === 2 ? (
                    <>
                      {Apiuser?.is_verified === 0 ? (
                        <div>
                          <h4 className="text-start  fw-700 pb-4 fs-3">
                            Verify{" "}
                            <span className=" color-secondary">
                              {" "}
                              your identity{" "}
                            </span>
                          </h4>
                          <div className="BecomeAlertMsg">
                            <h5 className="fw-600 fs-6 pb-2">
                              You have to verify your identity before becoming a
                              member.
                            </h5>
                            <div className="ps-2">
                              <h6>ID Check</h6>
                              <p>
                                Please submit your identity documents to become
                                a member on the FameWheels Platform.
                              </p>
                              <button
                                onClick={goToVerify}
                                type="button"
                                className="btn  fw-primary model_loginBTn px-3 py-1 fw-500 fs-6"
                              >
                                Verify
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : Apiuser?.is_verified === 2 ? (
                        <div>
                          <h4 className="text-start  fw-700 pb-1 fs-3">
                            Identity{" "}
                            <span className=" color-secondary">
                              {" "}
                              Verification Inprocess...{" "}
                            </span>
                          </h4>
                          <div className="BecomeAlertMsg">
                            <div>
                              <p>
                                We will shortly respond to your application.
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <div className="row mb-3">
                      <div className="col-md-6 col-12 mb-3">
                        <div className="mb-md-3">
                          <label for="memberName" className="form-label">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="ppmpf_1"
                            id="memberName"
                            placeholder="Enter Your Full Name"
                            required
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-12 mb-3">
                        <div className="mb-md-3">
                          <label for="memberEmail" className="form-label">
                            Email Address
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="ppmpf_2"
                            id="memberEmail"
                            placeholder="Enter Your Email Address"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-12 mb-3">
                        <div className="mb-md-3">
                          <label for="memberContact" className="form-label">
                            Phone Number
                          </label>
                          <InputMask
                            mask="03999999999"
                            maskChar={null}
                            type="text"
                            name="ppmpf_3"
                            className="form-control"
                            id="memberContact"
                            placeholder="03xxxxxxxxx"
                            required
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-12 mb-3">
                        <div className="mb-md-3">
                          <label for="memberCnic" className="form-label">
                            CNIC#
                          </label>
                          <InputMask
                            mask="99999-9999999-9"
                            maskChar={null}
                            type="text"
                            name="ppmpf_4"
                            className="form-control"
                            id="cnic"
                            placeholder="Enter Your Cnic"
                            required
                            value={cnic}
                            onChange={(e) => setCnic(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="bidPriceInc d-flex justify-content-between align-items-center px-2 py-1">
                        <button
                          onClick={decreaseValue}
                          disabled={value <= 10000}
                        >
                          -
                        </button>
                        <span>PKR {formatPrice(value)}</span>
                        <button onClick={increaseValue}>+</button>
                      </div>
                      <div className="col-6 p-0 text-center">
                        <button
                          onClick={handleFormSubmit}
                          type="submit"
                          className="btn mt-3 fw-primary model_loginBTn px-4 py-1 fw-500 fs-5 "
                          disabled={password !== confirmPassword}
                        >
                          continue
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
